import React from 'react';
import IconButton, {IconButtonProps} from '@mui/material/IconButton';
import {alpha, keyframes, styled} from '@mui/material/styles';

// Shake keyframes with a subtle pause
const shake = keyframes`
  0% { transform: translateX(1px); }
  10% { transform: translateX(-1px); }
  20% { transform: translateX(2px); }
  30% { transform: translateX(-2px); }
  40% { transform: translateX(1px); }
  50% { transform: translateX(-1px); }
  60%, 100% { transform: translateX(0); } /* Pause */
`;

interface StyledProps {
    $shake: boolean;
    $elevate?: boolean;
}

const StyledIconButton = styled(IconButton, {
    shouldForwardProp: prop => prop !== '$shake' && prop !== '$elevate',
})<StyledProps>(({$shake, $elevate, theme}) => ({
    animation: $shake ? `${shake} 1.5s ease-in-out infinite` : 'none',
    willChange: $shake ? 'transform' : 'auto',
    ...(!!$elevate && {
        backgroundColor: '#fff', //alpha(theme.palette.primary.main, 0.05),
        boxShadow: theme.shadows[3],
        '&:hover': {
            backgroundColor: alpha(theme.palette.primary.main, 0.1),
            transform: 'scale(1.05)',
        },
    }),
}));

interface AppShakingIconButtonProps extends IconButtonProps {
    shouldShake?: boolean;
    elevate?: boolean;
}

export const AppShakingIconButton: React.FC<AppShakingIconButtonProps> = React.memo(
    ({shouldShake = false, elevate = false, children, ...rest}) => (
        <StyledIconButton $shake={shouldShake} $elevate={elevate} {...rest}>
            {children}
        </StyledIconButton>
    ),
);

export default AppShakingIconButton;
